var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTagsAndLabels = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0001 14C21.7909 14 20.0001 12.2091 20.0001 10C20.0001 7.79086 21.7909 6 24.0001 6C26.2092 6 28.0001 7.79086 28.0001 10C28.0001 12.2091 26.2092 14 24.0001 14ZM24.0001 12C22.8955 12 22.0001 11.1046 22.0001 10C22.0001 8.89543 22.8955 8 24.0001 8C25.1046 8 26.0001 8.89543 26.0001 10C26.0001 11.1046 25.1046 12 24.0001 12Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.0001 13.7574V4C34.0001 1.79086 32.2092 0 30.0001 0H20.2427C19.1818 0 18.1644 0.421428 17.4143 1.17157L1.41425 17.1716C-0.147831 18.7337 -0.147851 21.2663 1.41421 22.8284L11.1716 32.5861C12.7337 34.1483 15.2664 34.1483 16.8285 32.5861L32.8285 16.5858C33.5787 15.8356 34.0001 14.8182 34.0001 13.7574ZM30.0001 2C31.1046 2 32.0001 2.89543 32.0001 4L32.0001 13.7574C32.0001 14.2878 31.7894 14.7965 31.4143 15.1716L15.4143 31.1719C14.6333 31.953 13.3669 31.953 12.5858 31.1719L2.82844 21.4142C2.04741 20.6332 2.04742 19.3669 2.82846 18.5858L18.8285 2.58579C19.2036 2.21071 19.7123 2 20.2427 2L30.0001 2Z",
    fill: "#071A24",
    fillOpacity: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgTagsAndLabels);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/tags-and-labels.f8415ee6c6d05285111fc2cd14463218.svg";